import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { Menu } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { DrawerModule } from 'primeng/drawer';
import { CandidaturaDetalheComponent } from '../candidatura-detalhe/candidatura-detalhe.component';
import { EstadoCandidaturaDescPipe } from '@app/shared/pipes/estado-candidatura-desc.pipe';
import {
  Candidatura,
  CandidaturaListItemDTO,
} from '@app/features-modules/bolsa-de-profissionais/api';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { Pagination } from '../../../../../shared/model/pagination.model';
import { TagModule } from 'primeng/tag';
import {
  Vaga,
  VagaListItemDTO,
  TipoProfissionalEnum,
  ProfissaoCatalogoListItemDTO,
} from '@app/features-modules/bolsa-de-profissionais/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Select } from 'primeng/select';
import { FilterItem } from '../../../../gestao-bolseiros/components/api/models/filterItem.model';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { CandidaturaService, VagaService } from '../../../services';
import { ApiService } from '@core/providers/http';
import { DialogModule } from 'primeng/dialog';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { ProfissionaisEnumService } from '../../../services';
import { EmpresaSectorService } from '../../../services';
import { ProfissaoCatalogoService } from '../../../services';
import { InputTextModule } from 'primeng/inputtext';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';

@Component({
  selector: 'app-lista-candidaturas',
  imports: [
    CommonModule,
    TableModule,
    Menu,
    ButtonModule,
    EstadoCandidaturaDescPipe,
    DrawerModule,
    CandidaturaDetalheComponent,
    PaginatorControlComponent,
    TagModule,
    Select,
    SearchBarComponent,
    DataVoidComponent,
    DialogModule,
    ReactiveFormsModule,
    InputTextModule,
    BackButtonComponent,
  ],
  providers: [DialogService, ApiService, CandidaturaService, VagaService],
  templateUrl: './lista-candidaturas.component.html',
  styleUrl: './lista-candidaturas.component.scss',
})
export class ListaCandidaturasComponent {
  router = inject(Router);
  vagaService = inject(VagaService);
  dialogService = inject(DialogService);
  profissionalenumService = inject(ProfissionaisEnumService);
  profissaoService = inject(ProfissaoCatalogoService);
  empresaService = inject(EmpresaSectorService);
  listaVagas: VagaListItemDTO[] = [];
  listaProfissoes: ProfissaoCatalogoListItemDTO[] = [];

  listaEmpresas: any[] = [];
  NivelAcademicoList: any[] = [];
  listaRegimeTrabalho: any[] = [];
  filter = {
    profissionalId: 0,
    vagaId: 0,
  };
  pagination: Pagination<any> = new Pagination<any>();
  candidaturaService = inject(CandidaturaService);
  candidaturaSelecionada: Candidatura | undefined | null;
  first = 0;
  rows = 5;
  accoes: MenuItem[] = [];
  showDetalhe = false;

  form!: FormGroup;
  constructor(public fb: FormBuilder) { }

  groupPersonList = [
    { label: 'Responsável', value: 1 },
    { label: 'Técnico', value: 2 },
    { label: 'Operário', value: 3 },
    { label: 'Administração e Serviços', value: 4 },
  ];

  estadoOption = [
    { id: 1, designacao: 'Em Análise' },
    { id: 2, designacao: 'Contratado' },
    { id: 3, designacao: 'Não Contratado' },
  ];

  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'codigo',
      placeholder: 'Código da Candidatura',
    },
    {
      type: 'text',
      controlName: 'NumBI',
      placeholder: 'Bilhete de Identidade',
    },
    {
      type: 'dropdown',
      controlName: 'VagaID',
      placeholder: 'Profissções com Vagas',
      options: this.listaVagas,
      optionLabel: 'designacaoFuncao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EmpresaID',
      placeholder: 'Empresa',
      options: this.listaEmpresas,
      optionLabel: 'nome',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'regime',
      placeholder: 'Regime de Trabalho',
      options: this.listaRegimeTrabalho,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'grupoTrabalho',
      placeholder: 'Grupo de Trabalho',
      options: this.groupPersonList,
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'dropdown',
      controlName: 'EstadoVaga',
      placeholder: 'Estado',
      options: this.estadoOption,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'nivelAcademico',
      placeholder: 'Nível Acadêmico',
      options: this.NivelAcademicoList,
      optionLabel: 'label',
      optionValue: 'id',
    },
  ];

  sortFields: any[] = [
    { label: 'Código', value: 'codigo' },
    { label: 'nome', value: 'nome' },
    { label: 'Numero do BI', value: 'NumBI' },
  ];

  candidaturasCount: any;

  ngOnInit() {
    this.getCandidaturas();
    this.getVagas();
    this.getProfissoes();
    this.getAllEmpresas();
    this.loadDropdowns();

    this.form = this.fb.group({
      codigo: [null],
      NumBI: [null],
      VagaID: [null],
      EmpresaID: [null],
      regime: [null],
      grupoTrabalho: [null],
      EstadoVaga: [null],
      nivelAcademico: [null],
    });
  }

  loadDropdowns() {
    forkJoin({
      regime: this.profissionalenumService.getAllRegimeTrabalho(),
      nivelAcademico: this.profissionalenumService.getAllNivelHabilitacao(),
    }).subscribe((response) => {
      if (response.regime?.data) {
        this.listaRegimeTrabalho = Object.entries(response.regime.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          })
        );
        // this.filters[3]!.options = this.listaRegimeTrabalho;
      }
      if (response.nivelAcademico?.data) {
        this.NivelAcademicoList = Object.entries(
          response.nivelAcademico.data
        ).map(([key, value]) => ({
          id: Number(key),
          label: value,
        }));
        // this.filters[6]!.options = this.NivelAcademicoList;
      }
    });
  }

  getProfissoes() {
    this.profissaoService.list().subscribe((result) => {
      if (result.data) {
        this.listaProfissoes = result.data;
        if (this.filters[10]) {
          this.filters[10].options = this.listaProfissoes.map((profissao) => ({
            ...profissao,
            designacaoISCO: `${profissao.codigoISCO} - ${profissao.designacaoISCO}`,
          }));
        }
      }
    });
  }

  getAllEmpresas(filters?: any) {
    const params = {
      pageNumber: 1,
      pageSize: 100,
      ...filters,
    };
    this.empresaService.list(params).subscribe(
      (res: any) => {
        this.listaEmpresas = res.data;
        const empresaFilter = this.filters.find((f) => f.controlName === 'EmpresaID');
        if (empresaFilter) {
          empresaFilter.options = this.listaEmpresas;
        }
      },
      () => {
        this.listaEmpresas = [];
      }
    );
  }

  getVagas() {
    this.vagaService.list().subscribe((concursos) => {
      this.listaVagas = concursos.data ?? [];
      const vagaFilter = this.filters.find((f) => f.controlName === 'VagaID');
      if (vagaFilter) {
        vagaFilter.options = this.listaVagas;
      }
    });
  }

  getCandidaturas(queryParams: any = {}) {
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
    };
    this.candidaturaService.list(params).subscribe((candidaturas) => {
      this.pagination = new Pagination<any>().deserialize(candidaturas);
      this.candidaturasCount = this.pagination?.totalRecords;
    });
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ''
      )
    );
    this.getCandidaturas(filters);
  }

  getSeverity(estado: string): any {
    switch (estado) {
      case 'Em Análise':
        return 'warn';
      case 'Contratado':
        return 'success';
      case 'Não Contratado':
        return 'danger';
      default:
        return 'warn';
    }
  }

  actionClick(candidatura: Candidatura) {
    this.showDetalhe = true;
    this.candidaturaSelecionada = candidatura;
  }

  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getCandidaturas();
  }

  showFilter = false;

  showDialog() {
    this.showFilter = true;
  }
}
